import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { missingReceiptsExcelExportActions } from "../_store";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
export function MissingReceiptsExportModal(props) {
    const [excel, setExcel] = useState(false);
    const dispatch = useDispatch();
    let getFilterObj;
    let { missingReceiptsExcelExport } = useSelector(x => x.missingReceiptsExcelExport);
    
    useEffect(() => {
        if (localStorage.getItem('missingReceiptsFilterValues')) {
            getFilterObj = JSON.parse(localStorage.getItem('missingReceiptsFilterValues'))
            // dispatch(excelExportActions.getAll(getFilterObj));
        }

    }, [])


    const cancelModal = () => {
        props.onHide();
        setExcel(false)
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (excel) {
            if (localStorage.getItem('missingReceiptsFilterValues')) {
                getFilterObj = JSON.parse(localStorage.getItem('missingReceiptsFilterValues'))
                getFilterObj.pageNumber = '';
                getFilterObj.pageSize='';
                dispatch(missingReceiptsExcelExportActions.getAll(getFilterObj));
            }           

        }

    }
    useEffect(() => {
        if(missingReceiptsExcelExport.result) {
            const link = document.createElement('a');
            link.href = missingReceiptsExcelExport.result.fileRelativePath + '/' + missingReceiptsExcelExport.result.fileName;
            link.download = 'MissingReceipts.xlsx'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
           
            props.onHide();
            setExcel(false);
        }
    },[missingReceiptsExcelExport])
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="export-modal filter-modal"
            >
            <h4>Export Files</h4>
            <Modal.Body>
                <div className="form-overlay">
                    <div className="receipts edit-receipts">
                        {missingReceiptsExcelExport?.loading &&
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>}

                        <Form onSubmit={handleSubmit}>
                            <div className='export-dashboard'>
                                {!missingReceiptsExcelExport?.loading &&
                                    <div key='export-excel' className="checkbox-export">
                                        <Form.Check
                                            type="checkbox"
                                            id='export-excel'
                                            label="Export To Excel"
                                            required
                                            onChange={(event) => setExcel(event.target.checked)}
                                        />

                                        <Form.Check
                                            disabled
                                            type="checkbox"
                                            id='export-pdf'
                                            label="Export To PDF"
                                        />
                                        {missingReceiptsExcelExport?.error &&
                                            <div className='error-msg'>{missingReceiptsExcelExport?.error.message}</div>}
                                    </div>
                                }

                            </div>
                            <div className='flex'>
                                <OverlayTrigger
                                    key='bottom-filter'
                                    placement='bottom'
                                    overlay={
                                        <Tooltip id='tooltip-filter'>
                                            Export
                                        </Tooltip>
                                    }
                                >
                                    <Button type="submit"> <img src={'/assets/icons/checkmark.svg'} /></Button>

                                </OverlayTrigger>
                                <OverlayTrigger
                                    key='bottom-cancel'
                                    placement='bottom'
                                    overlay={
                                        <Tooltip id='tooltip-cancel'>
                                            Cancel
                                        </Tooltip>
                                    }
                                >
                                    <Button onClick={cancelModal} className="close-button"> <img src={'/assets/icons/close.svg'} /></Button>
                                </OverlayTrigger>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal.Body>

        </Modal>
    );

}